import React from "react"
import { Box } from "@mui/material"
import styles from "./ModalDefault.module.scss"

export interface ModalCommonTemplateProps {
  title?: string
  child?: React.ReactNode
}
/**
 * モーダルの共通テンプレート（引数としてReactNodeを渡す）
 * @param {string} title - モーダルのタイトル
 * @param {string} child - モーダルの中身（HTML）
 */
const ModalCommonTemplate = ({ title, child }: ModalCommonTemplateProps) => {
  return (
    <>
      <Box className={styles.modalTitle}>
        <h3>{title}</h3>
      </Box>
      <Box className={styles.modalParagraph}>
        <div className={styles.childContainer}>{child}</div>
      </Box>
    </>
  )
}

export default ModalCommonTemplate
